import React, { useState } from 'react';
import RetailCategoryPrices from './RetailCategoryPrices';
import { HEADER_CELL } from '../../utils/tableColumns';

export default function DistributorCustomerTable({ clinics, selectedId, onView, t }) {
  const [requestedPage, setPage] = useState(1);
  const pages = Math.max(1, Math.ceil(clinics.length / 20));
  const page = Math.min(requestedPage, pages);
  const start = (page - 1) * 20;
  return (
    <div className="me-dw-card overflow-hidden">
      <div
        className="me-dw-activity-table-scroll"
        tabIndex={0}
        role="region"
        aria-label={t('Customer list')}
      >
        <table className="me-dw-activity-table me-dw-customer-table" aria-label={t('Customers')}>
          <thead>
            <tr>
              {['Customer', 'Retail pricing', 'Ordering', 'Actions'].map((label) => (
                <th key={label} scope="col" className={HEADER_CELL}>
                  {t(label)}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {clinics.slice(start, start + 20).map((clinic) => (
              <tr key={clinic._id} data-active={selectedId === clinic._id}>
                <td className="font-semibold text-[#24424a]" id={`customer-name-${clinic._id}`}>
                  {clinic.name}
                </td>
                <td className="whitespace-nowrap">
                  <RetailCategoryPrices settings={clinic.settings} t={t} />
                </td>
                <td>
                  <span
                    className={`me-dw-status whitespace-nowrap ${clinic.settings?.orderingEnabled === false ? 'me-dw-customer-disabled' : ''}`}
                  >
                    {t(
                      clinic.settings?.orderingEnabled === false
                        ? 'Ordering disabled'
                        : 'Ordering enabled'
                    )}
                  </span>
                </td>
                <td>
                  <button
                    type="button"
                    className="me-dw-link"
                    aria-describedby={`customer-name-${clinic._id}`}
                    onClick={() => onView(clinic._id)}
                  >
                    {t('View')}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="flex flex-wrap items-center justify-between gap-3 px-4 py-3 text-xs text-[#5e737a]">
        <span>
          {t('Showing {start}–{end} of {total}', {
            start: start + 1,
            end: Math.min(start + 20, clinics.length),
            total: clinics.length,
          })}
        </span>
        {pages > 1 && (
          <nav className="me-dw-pagination" aria-label={t('Customer pages')}>
            <button type="button" disabled={page === 1} onClick={() => setPage(page - 1)}>
              {t('Previous')}
            </button>
            <span>
              {page} / {pages}
            </span>
            <button type="button" disabled={page === pages} onClick={() => setPage(page + 1)}>
              {t('Next')}
            </button>
          </nav>
        )}
      </div>
    </div>
  );
}
